import { ProjectType, SkillType } from "./types";

export const Projects: ProjectType[] = [
  {
    index: 1,
    name: "Noor",
    url: "https://noor-godhra.vercel.app/",
    href: "/our-work/noor",
    tag1: "Luxury E-Commerce & Jewellery Catalog",
    tag2: "Exquisite handcrafted jewellery catalog with bespoke design systems.",
    image_Gradient:
      "bg-linear-to-tr from-transparent via-amber-600/10 to-transparent dark:from-transparent dark:via-amber-200/10 dark:to-transparent backdrop-blur-[1px] border-2 border-amber-200/10",
    description:
      "Designed and engineered 'Noor', a luxury Indian jewellery showcase and e-commerce platform. Built with Next.js and Tailwind CSS, utilizing React Aria Components for high-performance accessibility, and Framer Motion to orchestrate fluid, high-end interactive animations suited for a premium brand.",
    gradient_light:
      "bg-linear-to-r bg-white dark:bg-main from-white dark:from-main to-amber-500/20 dark:to-amber-800/20 border-2 border-amber-500/20 dark:border-amber-800/20",
    img: "https://res.cloudinary.com/dqa59akgo/image/upload/v1779896513/jignesh-baria/noor/image_209_fdo4dt.png",
    imgDark:
      "https://res.cloudinary.com/dqa59akgo/image/upload/v1779896514/jignesh-baria/noor/image_210_pewl2n.png",
    dark: true,
    tech: [
      "NextJS 16",
      "TypeScript",
      "Tailwind CSS 4",
      "HeroUI 3",
      "Motion",
      "Firebase",
      "Zustand",
      "Zod",
      "Razorpay",
      "ImageKit",
      "Lenis",
    ],
    techIcons: [
      { name: "NextJS 16", icon: "nextjs" },
      { name: "TypeScript", icon: "typescript" },
      { name: "Tailwind CSS 4", icon: "tailwindcss" },
      { name: "Motion", icon: "framer" },
      { name: "Firebase", icon: "firebase" },
      { name: "Zustand", icon: "zustand" },
      { name: "Zod", icon: "zod" },
    ],
    features: [
      "Live Global Market Pricing",
      "Granular Sizing Inventory",
      "Client-Side Media Compression",
      "Touch-Optimized Adaptive UI",
      "Secure Mobile App APIs",
      "Luxury Storytelling & Motion",
    ],
    featureDescription: [
      "Dynamically recalculate pricing in real-time based on per-gram live metal rates and making charges.",
      "Track and toggle stock quantities per specific ring or bracelet size to prevent overselling.",
      "Scale and convert high-res photoshoot assets into lightweight WebP format on the device prior to upload.",
      "Ergonomic mobile layouts featuring sliding bottom-sheet drawers, touch filters, and swipeable carousels.",
      "Harden endpoints with x-api-key authentication and cryptographic signature checks for native mobile clients.",
      "Buttery-smooth inertial scroll via Lenis combined with staggered hover states and scroll-linked reveals.",
    ],
    impact: [
      "Delivered a centralized Admin Control Panel that automates product pricing calculations based on fluctuating market rates.",
      "Engineered a secure, HMAC-validated API gateway for native mobile applications to conduct checkout and verification safely.",
      "Optimized database storage overhead and client bandwidth by processing and compressing media assets dynamically on-device.",
    ],
    challenges: [
      {
        challenge: "Managing dynamic pricing calculation for jewelry based on fluctuating global metal rates.",
        solution:
          "Architected an administrative pricing engine that dynamically computes product prices based on per-gram metal weights, diamond carats, and making charges.",
      },
      {
        challenge: "Optimizing heavy product photoshoot images before cloud storage uploads to save bandwidth.",
        solution:
          "Built a client-side WebP compression pipeline using Canvas API to optimize and scale images on the admin panel before upload.",
      },
      {
        challenge: "Securing payment hooks and API access for external native iOS and Android apps.",
        solution:
          "Designed a secure API layer under /api/mobile verified with x-api-key headers and secure HMAC-SHA256 signature validation for payments.",
      },
    ],
    desktopScreenshots: [
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1779897150/jignesh-baria/noor/image_209_oixjzi.webp",
        title: "Home Screen",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1779897142/jignesh-baria/noor/image_210_nb4vmb.webp",
        title: "Home Screen",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1779897069/jignesh-baria/noor/image_212_crjwtc.webp",
        title: "Category",
        type: "light",
      },
      {
        image: "https://res.cloudinary.com/dqa59akgo/image/upload/v1779897053/jignesh-baria/noor/image_211_xplgrc.webp",
        title: "Category",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1779897055/jignesh-baria/noor/image_213_snrron.webp",
        title: "Curated Collection",
        type: "light",
      },
      {
        image: "https://res.cloudinary.com/dqa59akgo/image/upload/v1779897045/jignesh-baria/noor/image_214_j9xsam.webp",
        title: "Curated Collection",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1779897051/jignesh-baria/noor/image_227_ovpre6.webp",
        title: "Cart",
        type: "light",
      },
      {
        image: "https://res.cloudinary.com/dqa59akgo/image/upload/v1779897053/jignesh-baria/noor/image_228_vp4hyy.webp",
        title: "Cart",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1779897051/jignesh-baria/noor/image_226_l94ywb.webp",
        title: "Search",
        type: "light",
      },
      {
        image: "https://res.cloudinary.com/dqa59akgo/image/upload/v1779897050/jignesh-baria/noor/image_225_exoyrk.webp",
        title: "Search",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1779897049/jignesh-baria/noor/image_223_rjmyg5.webp",
        title: "Bespoke",
        type: "light",
      },
      {
        image: "https://res.cloudinary.com/dqa59akgo/image/upload/v1779897050/jignesh-baria/noor/image_224_ztjp6k.webp",
        title: "Bespoke",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1779897049/jignesh-baria/noor/image_222_st99os.webp",
        title: "Collection",
        type: "light",
      },
      {
        image: "https://res.cloudinary.com/dqa59akgo/image/upload/v1779897048/jignesh-baria/noor/image_221_xwle5y.webp",
        title: "Collection",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1779897047/jignesh-baria/noor/image_219_ckkue2.webp",
        title: "Category Page",
        type: "light",
      },
      {
        image: "https://res.cloudinary.com/dqa59akgo/image/upload/v1779897048/jignesh-baria/noor/image_220_qv05cy.webp",
        title: "Category Page",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1779897046/jignesh-baria/noor/image_216_lxlom1.webp",
        title: "Reviews",
        type: "light",
      },
      {
        image: "https://res.cloudinary.com/dqa59akgo/image/upload/v1779897045/jignesh-baria/noor/image_215_tlort2.webp",
        title: "Reviews",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1779897046/jignesh-baria/noor/image_217_tcqrgt.webp",
        title: "Footer",
        type: "light",
      },
      {
        image: "https://res.cloudinary.com/dqa59akgo/image/upload/v1779897047/jignesh-baria/noor/image_218_nxipz0.webp",
        title: "Footer",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1779897053/jignesh-baria/noor/image_230_sfk9jf.webp",
        title: "Orders",
        type: "light",
      },
      {
        image: "https://res.cloudinary.com/dqa59akgo/image/upload/v1779897052/jignesh-baria/noor/image_229_jimb2r.webp",
        title: "Orders",
        type: "dark",
      },
    ],
    mobileScreenshots: [
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1779896677/jignesh-baria/noor/Screenshot_20260527-190516_noorjewellers_rs3lzh.webp",
        title: "Home Screen",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1779896677/jignesh-baria/noor/Screenshot_20260527-190458_noorjewellers_dykl5v.webp",
        title: "Home Screen",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1779896678/jignesh-baria/noor/Screenshot_20260527-190541_noorjewellers_rrohdn.webp",
        title: "Category",
        type: "light",
      },
      {
        image: "https://res.cloudinary.com/dqa59akgo/image/upload/v1779896678/jignesh-baria/noor/Screenshot_20260527-190625_noorjewellers_xioemg.webp",
        title: "Category",
        type: "dark",
      },
      {
        image: "https://res.cloudinary.com/dqa59akgo/image/upload/v1779896679/jignesh-baria/noor/Screenshot_20260527-190635_noorjewellers_vndp5u.webp",
        title: "Curated Collection",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1779896674/jignesh-baria/noor/Screenshot_20260527-191433_noorjewellers_pvamp5.webp",
        title: "Cart",
        type: "light",
      },
      {
        image: "https://res.cloudinary.com/dqa59akgo/image/upload/v1779897042/jignesh-baria/noor/Screenshot_20260527-191324_noorjewellers_ittbvn.webp",
        title: "Cart",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1779897043/jignesh-baria/noor/Screenshot_20260527-191403_noorjewellers_iw2iso.webp",
        title: "Search",
        type: "light",
      },
      {
        image: "https://res.cloudinary.com/dqa59akgo/image/upload/v1779897032/jignesh-baria/noor/Screenshot_20260527-190757_noorjewellers_sqkytm.webp",
        title: "Search",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1779896674/jignesh-baria/noor/Screenshot_20260527-191420_noorjewellers_ilgcfs.webp",
        title: "Checkout",
        type: "light",
      },
      {
        image: "https://res.cloudinary.com/dqa59akgo/image/upload/v1779897032/jignesh-baria/noor/Screenshot_20260527-190856_noorjewellers_a97n4l.webp",
        title: "Checkout",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1779896676/jignesh-baria/noor/Screenshot_20260527-191632_noorjewellers_o8hetq.webp",
        title: "Collection",
        type: "light",
      },
      {
        image: "https://res.cloudinary.com/dqa59akgo/image/upload/v1779897032/jignesh-baria/noor/Screenshot_20260527-190646_noorjewellers_s4zptm.webp",
        title: "Collection",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1779896675/jignesh-baria/noor/Screenshot_20260527-191523_noorjewellers_zwawlu.webp",
        title: "Category Page",
        type: "light",
      },
      {
        image: "https://res.cloudinary.com/dqa59akgo/image/upload/v1779897042/jignesh-baria/noor/Screenshot_20260527-191103_noorjewellers_yv1e0h.webp",
        title: "Category Page",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1779896674/jignesh-baria/noor/Screenshot_20260527-191502_noorjewellers_qlszug.webp",
        title: "Explore",
        type: "light",
      },
      {
        image: "https://res.cloudinary.com/dqa59akgo/image/upload/v1779897032/jignesh-baria/noor/Screenshot_20260527-190722_noorjewellers_crmu1r.webp",
        title: "Explore",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1779896676/jignesh-baria/noor/Screenshot_20260527-191839_noorjewellers_vmdrmv.webp",
        title: "Product Page",
        type: "light",
      },
      {
        image: "https://res.cloudinary.com/dqa59akgo/image/upload/v1779897042/jignesh-baria/noor/Screenshot_20260527-191132_noorjewellers_nhkqxl.webp",
        title: "Product Page",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1779897043/jignesh-baria/noor/Screenshot_20260527-191348_noorjewellers_t8jv1j.webp",
        title: "Orders",
        type: "light",
      },
      {
        image: "https://res.cloudinary.com/dqa59akgo/image/upload/v1779897042/jignesh-baria/noor/Screenshot_20260527-191324_noorjewellers_ittbvn.webp",
        title: "Orders",
        type: "dark",
      },
      {
        image: "https://res.cloudinary.com/dqa59akgo/image/upload/v1779897040/jignesh-baria/noor/Screenshot_20260527-190914_noorjewellers_zfxlyd.webp",
        title: "Profile",
        type: "dark",
      },
      {
        image: "https://res.cloudinary.com/dqa59akgo/image/upload/v1779897041/jignesh-baria/noor/Screenshot_20260527-190925_noorjewellers_nyujno.webp",
        title: "Setting",
        type: "dark",
      },
    ],
    mainPagePoster: [
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1779895979/jignesh-baria/noor/reuseable_bja4c8.png",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1779895979/jignesh-baria/noor/reuseable_1_drsoxq.png",
        type: "dark",
      },
    ],
  },
  {
    index: 2,
    name: "Zari",
    url: "https://zari-clothing.vercel.app/",
    href: "/our-work/zari",
    tag1: "Enterprise-Grade E-Commerce Platform",
    tag2: "Scalable architecture with secure payments & real-time inventory.",
    image_Gradient:
      "bg-linear-to-tr from-transparent via-indigo-600/10 to-transparent dark:from-transparent dark:via-indigo-200/10 dark:to-transparent backdrop-blur-[1px] border-2 border-indigo-200/10",
    description:
      "Architected a high-performance e-commerce platform using Next.js 16 App Router. Engineered complex global state management with Zustand for seamless user sessions, integrated secure payment processing via Razorpay webhooks, and enforced strict runtime data integrity with Zod.",
    gradient_light:
      "bg-linear-to-r dark:bg-main bg-white from-white dark:from-main to-indigo-500/20 dark:to-indigo-800/20 border-2 border-indigo-500/20 dark:border-indigo-800/20",
    img: "https://res.cloudinary.com/dqa59akgo/image/upload/v1770543033/jignesh-baria/posters/Poject_Poster/zari_light_i0fpa3.webp",
    imgDark:
      "https://res.cloudinary.com/dqa59akgo/image/upload/v1770543032/jignesh-baria/posters/Poject_Poster/zari_dark_yheuuo.webp",
    dark: true,
    tech: [
      "NextJS 16",
      "NodeJS",
      "TypeScript",
      "Razorpay",
      "Tailwind CSS",
      "Firebase",
      "Zod",
      "axios",
      "Framer-Motion",
      "Zustand",
      "imagekit.io",
      "tiptap Rich-text editor",
    ],
    techIcons: [
      { name: "NextJS 16", icon: "nextjs" },
      { name: "NodeJS", icon: "nodejs" },
      { name: "TypeScript", icon: "typescript" },
      { name: "Tailwind CSS", icon: "tailwindcss" },
      { name: "Firebase", icon: "firebase" },
      { name: "Zod", icon: "zod" },
      { name: "Framer-Motion", icon: "framer" },
      { name: "Zustand", icon: "zustand" },
      { name: "Axios", icon: "axios" },
      { name: "ImageKit", icon: "imagekit" },
      { name: "Tiptap", icon: "tiptap" },
    ],
    features: [
      "Secure Razorpay Payment Integration",
      "Real-time Cart Management with Zustand",
      "Admin Dashboard for Product/Order Management",
      "Optimized Image Delivery via ImageKit",
      "Runtime Schema Validation with Zod",
      "Persistent User Sessions",
    ],
    featureDescription: [
      "Process transactions securely with industry-standard encryption and fraud protection.",
      "Sync shopping cart state instantly across devices and browser sessions.",
      " Comprehensive backend for managing inventory, tracking orders, and analyzing sales data.",
      "Serve high-resolution product images in next-gen formats with automatic optimization.",
      "Ensure data integrity with strict type checking and validation at runtime.",
      "Keep users logged in securely with robust session management and token handling.",
    ],
    impact: [
      "Delivered a friction-less e-commerce experience handling complex concurrent user sessions.",
      "Engineered an optimized architecture ensuring sub-second load times and high availability.",
      "Maximized conversion rates through a seamless, cross-device shopping experience.",
    ],
    challenges: [
      {
        challenge: "Managing complex global state for cart sessions.",
        solution:
          "Implemented Zustand for efficient, scalable state management across the application.",
      },
      {
        challenge: "Ensuring data integrity during checkout.",
        solution:
          "Utilized Zod for strict runtime schema validation to prevent errors.",
      },
      {
        challenge: "Processing secure payments reliably.",
        solution:
          "Integrated Razorpay webhooks for real-time transaction updates and security.",
      },
    ],
    mainPagePoster: [
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770475404/jignesh-baria/posters/main_page/Gradient_3-3_rmpzkm.webp",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770475404/jignesh-baria/posters/main_page/Gradient_3_hsqn3d.webp",
        type: "dark",
      },
    ],
    desktopScreenshots: [
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770473793/jignesh-baria/Zari/image_15_vn5f3q.webp",
        title: "Login",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770473793/jignesh-baria/Zari/image_16_r6c9p7.webp",
        title: "Login",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770473794/jignesh-baria/Zari/image_17_hdrfqz.webp",
        title: "Home",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770473793/jignesh-baria/Zari/image_18_rwhdp4.webp",
        title: "Home",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770473794/jignesh-baria/Zari/image_22_niq8dk.webp",
        title: "Featured Products",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770473793/jignesh-baria/Zari/image_21_afuryj.webp",
        title: "Featured Products",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770473794/jignesh-baria/Zari/image_20_a1nmnl.webp",
        title: "Sponsored Products",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770473794/jignesh-baria/Zari/image_19_muhg4b.webp",
        title: "Sponsored Products",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770473794/jignesh-baria/Zari/image_23_gvjpck.webp",
        title: "Product Page",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770473795/jignesh-baria/Zari/image_24_a6d9qs.webp",
        title: "Product Page",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770473795/jignesh-baria/Zari/image_28_s2zhvh.webp",
        title: "Whishlist",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770473795/jignesh-baria/Zari/image_27_ku1olo.webp",
        title: "Whishlist",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770473796/jignesh-baria/Zari/image_30_qdeki4.webp",
        title: "Bag",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770473795/jignesh-baria/Zari/image_29_adpc6k.webp",
        title: "Bag",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770473795/jignesh-baria/Zari/image_26_hpbyle.webp",
        title: "Women Collection",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770473796/jignesh-baria/Zari/image_25_neagry.webp",
        title: "Women Collection",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770473797/jignesh-baria/Zari/image_33_yuz0su.webp",
        title: "Search",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770473800/jignesh-baria/Zari/image_34_bkrwbw.webp",
        title: "Search",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770473800/jignesh-baria/Zari/image_35_tqppx8.webp",
        title: "Orders",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770473802/jignesh-baria/Zari/image_36_irlecu.webp",
        title: "Orders",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770473802/jignesh-baria/Zari/image_37_ncgtgc.webp",
        title: "Address",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770473801/jignesh-baria/Zari/image_38_cflitd.webp",
        title: "Address",
        type: "dark",
      },
    ],
    mobileScreenshots: [
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770473803/jignesh-baria/Zari/image_122_vdxtel.webp",
        title: "Home",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770473802/jignesh-baria/Zari/image_119_m1drsd.webp",
        title: "Home",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770473802/jignesh-baria/Zari/image_120_ikuowa.webp",
        title: "Featured Products",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770473803/jignesh-baria/Zari/image_121_q54xen.webp",
        title: "Featured Products",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770473806/jignesh-baria/Zari/image_123_nybfau.webp",
        title: "Sponsored Products",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770473807/jignesh-baria/Zari/image_124_poawyj.webp",
        title: "Sponsored Products",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770473808/jignesh-baria/Zari/image_125_qgt9jz.webp",
        title: "Product Page",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770473809/jignesh-baria/Zari/image_126_hs4jft.webp",
        title: "Product Page",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770473809/jignesh-baria/Zari/image_127_xg8b88.webp",
        title: "Whishlist",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770473815/jignesh-baria/Zari/image_130_ed4shj.webp",
        title: "Whishlist",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770473814/jignesh-baria/Zari/image_129_yobjls.webp",
        title: "Bag",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770473810/jignesh-baria/Zari/image_128_wp6qhn.webp",
        title: "Bag",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770473815/jignesh-baria/Zari/image_132_xmaitx.webp",
        title: "Search",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770473815/jignesh-baria/Zari/image_131_envvju.webp",
        title: "Search",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770473822/jignesh-baria/Zari/image_138_gmkwb7.webp",
        title: "Orders",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770473823/jignesh-baria/Zari/image_137_rpjnxq.webp",
        title: "Orders",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770473822/jignesh-baria/Zari/image_136_frbxo8.webp",
        title: "Address",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770473821/jignesh-baria/Zari/image_135_nny2r7.webp",
        title: "Address",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770473829/jignesh-baria/Zari/image_142_oofs6r.webp",
        title: "Menu",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770473829/jignesh-baria/Zari/image_141_fyonm0.webp",
        title: "Menu",
        type: "light",
      },
    ],
  },
  {
    index: 3,
    name: "Axiom",
    url: "https://axiom-quiz.vercel.app/",
    href: "/our-work/axiom",
    tag1: "AI-Powered EdTech SaaS",
    tag2: "Generative AI content synthesis with role-based access control.",
    image_Gradient:
      "bg-linear-to-tr from-transparent via-purple-600/10 to-transparent dark:from-transparent dark:via-purple-200/10 dark:to-transparent backdrop-blur-[1px] border-2 border-purple-200/10",
    description:
      "Engineered an AI-powered content generation engine leveraging Google's Genkit and Gemini API for real-time quiz and summary synthesis. Built a scalable Next.js 15 application featuring server-side streaming and fine-grained access control using Razorpay integration.",
    gradient_light:
      "bg-linear-to-r bg-white dark:bg-main from-white dark:from-main to-purple-500/20 dark:to-purple-800/20 border-2 border-purple-500/20 dark:border-purple-800/20",
    img: "https://res.cloudinary.com/dqa59akgo/image/upload/v1770543022/jignesh-baria/posters/Poject_Poster/axiom_light_c783yt.webp",
    imgDark:
      "https://res.cloudinary.com/dqa59akgo/image/upload/v1770543021/jignesh-baria/posters/Poject_Poster/axiom_dark_z9gtz1.webp",
    dark: true,
    tech: [
      "NextJS 15",
      "NodeJS",
      "TypeScript",
      "Google Genkit",
      "Google Gemini API",
      "Razorpay",
      "Framer-Motion",
      "Tailwind CSS",
      "Zod",
      "Zustand",
      "Tiptap Rich-text editor",
      "imagekit.io",
    ],
    techIcons: [
      { name: "NextJS 15", icon: "nextjs" },
      { name: "NodeJS", icon: "nodejs" },
      { name: "TypeScript", icon: "typescript" },
      { name: "Google Genkit", icon: "google" },
      { name: "Google Gemini API", icon: "gemini" },
      { name: "Framer-Motion", icon: "framer" },
      { name: "Tailwind CSS", icon: "tailwindcss" },
      { name: "Zod", icon: "zod" },
      { name: "Zustand", icon: "zustand" },
      { name: "Tiptap", icon: "tiptap" },
      { name: "ImageKit", icon: "imagekit" },
    ],
    features: [
      "AI-Powered Quiz Generation (Genkit + Gemini)",
      "Real-time Content Streaming",
      "Context-Aware Summarization",
      "PDF/Text to Content Conversion",
      "Role-Based Access Control",
      "Responsive Quiz Interface",
    ],
    featureDescription: [
      "Dynamically create quizzes from any topic using advanced language models.",
      "Stream generative content in real-time for immediate user feedback.",
      "Automatically generate concise summaries from long-form content or documents.",
      "Extract and process content from PDF documents for quiz generation.",
      "Manage user permissions and subscription tiers with secure role-based logic.",
      "Enjoy a seamless experience across mobile, tablet, and desktop devices.",
    ],
    impact: [
      "Revolutionized access to AI learning tools by instantly synthesizing complex information into digestible quizzes.",
      "Constructed a scalable architecture supporting concurrent users generating real-time content streams.",
      "Transformed passive content consumption into active, engagement-driven learning.",
    ],
    challenges: [
      {
        challenge: "Generating high-quality AI content in real-time.",
        solution:
          "Leveraged Google's Genkit and Gemini API with server-side streaming.",
      },
      {
        challenge: "Managing tiered access to features.",
        solution:
          "Built a fine-grained role-based access control system integrated with Razorpay.",
      },
      {
        challenge: "Synthesizing quizzes from diverse inputs.",
        solution:
          "Created a robust PDF and text processing pipeline for the AI engine.",
      },
    ],
    desktopScreenshots: [
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770489042/jignesh-baria/axiom/image_2_k81n6t.webp",
        title: "Home",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770489041/jignesh-baria/axiom/image_1_wjmilw.webp",
        title: "Home",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770489042/jignesh-baria/axiom/image_3_ozmp9t.webp",
        title: "Login",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770489043/jignesh-baria/axiom/image_4_w8q41o.webp",
        title: "Login",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770489045/jignesh-baria/axiom/image_5_yxmj0x.webp",
        title: "Dashboard",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770489046/jignesh-baria/axiom/image_6_okrqcj.webp",
        title: "Dashboard",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770489048/jignesh-baria/axiom/image_7_lylw0g.webp",
        title: "Notes Page",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770489049/jignesh-baria/axiom/image_8_yk7cun.webp",
        title: "Notes Page",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770489052/jignesh-baria/axiom/image_10_ovbn3s.webp",
        title: "Plans Page",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770489053/jignesh-baria/axiom/image_11_yur1mr.webp",
        title: "Contact Page",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770489054/jignesh-baria/axiom/image_12_nsrzje.webp",
        title: "Contact Page",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770489058/jignesh-baria/axiom/image_14_aoqojy.webp",
        title: "Notes form Page",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770489057/jignesh-baria/axiom/image_13_yfcird.webp",
        title: "Notest form Page",
        type: "dark",
      },
    ],
    mobileScreenshots: [
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770489059/jignesh-baria/axiom/image_111_v5p0f4.webp",
        title: "Home",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770489061/jignesh-baria/axiom/image_112_lzv3mm.webp",
        title: "Home",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770489064/jignesh-baria/axiom/image_114_qbvtij.webp",
        title: "Login",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770489063/jignesh-baria/axiom/image_113_u0eeqh.webp",
        title: "Login",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770489068/jignesh-baria/axiom/image_116_vincn4.webp",
        title: "Dashboard",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770489065/jignesh-baria/axiom/image_115_xll3qo.webp",
        title: "Dashboard",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770489070/jignesh-baria/axiom/image_118_wkeawn.webp",
        title: "Notes Page",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770489070/jignesh-baria/axiom/image_117_qab0fs.webp",
        title: "Notest Page",
        type: "dark",
      },
    ],
    mainPagePoster: [
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770489674/jignesh-baria/posters/main_page/axiom_light_zvd1sn.webp",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770489673/jignesh-baria/posters/main_page/Axiom_dark_omr75e.webp",
        type: "dark",
      },
    ],
  },
  {
    index: 4,
    name: "Nest",
    url: "https://nestwebapp.vercel.app/",
    href: "/our-work/nest",
    tag1: "Real-Time Collaboration Suite",
    tag2: "Complex state management with optimistic UI & live synchronization.",
    image_Gradient:
      "bg-linear-to-tr from-transparent via-sky-600/10 to-transparent dark:from-transparent dark:via-sky-200/10 dark:to-transparent backdrop-blur-[1px] border-2 border-sky-200/10",
    description:
      "Developed a comprehensive project management SaaS with real-time collaboration updates using Firebase Firestore listeners. Constructed a complex nested data architecture for tasks, optimized with optimistic UI updates and Framer Motion for specific drag-and-drop workflows.",
    gradient_light:
      "bg-linear-to-r bg-white dark:bg-main from-white dark:from-main to-sky-500/20 dark:to-sky-800/20 border-2 border-sky-500/20 dark:border-sky-800/20",
    img: "https://res.cloudinary.com/dqa59akgo/image/upload/v1770543027/jignesh-baria/posters/Poject_Poster/nest_light_ms4n0w.webp",
    imgDark:
      "https://res.cloudinary.com/dqa59akgo/image/upload/v1770543026/jignesh-baria/posters/Poject_Poster/nest_dark_cz7usu.webp",
    dark: true,
    tech: [
      "NextJS 16",
      "NodeJS",
      "TypeScript",
      "Razorpay",
      "Tailwind CSS",
      "Firebase",
      "Zod",
      "axios",
      "Framer-Motion",
      "Zustand",
      "imagekit.io",
      "tiptap Rich-text editor",
    ],
    techIcons: [
      { name: "NextJS 16", icon: "nextjs" },
      { name: "NodeJS", icon: "nodejs" },
      { name: "TypeScript", icon: "typescript" },
      { name: "Tailwind CSS", icon: "tailwindcss" },
      { name: "Firebase", icon: "firebase" },
      { name: "Zod", icon: "zod" },
      { name: "Framer-Motion", icon: "framer" },
      { name: "Zustand", icon: "zustand" },
      { name: "Axios", icon: "axios" },
      { name: "ImageKit", icon: "imagekit" },
      { name: "Tiptap", icon: "tiptap" },
    ],
    features: [
      "Real-time Collaboration (MongoDB & Ably)",
      "Nested Task Management System",
      "Drag-and-Drop Task Organization",
      "Optimistic UI Updates",
      "Team & Project Workspaces",
      "Rich Text Description Editors",
    ],
    featureDescription: [
      "Interact with your team instantly. Updates sync across all devices in milliseconds.",
      "Break down complex projects into infinite sub-tasks. Organize work hierarchically.",
      "Prioritize with ease. Smooth drag-and-drop interactions powered by simple mouse movements.",
      "Experience zero latency. The interface updates instantly while data syncs in the background.",
      "Create dedicated environments for different teams. Manage member access effortlessly.",
      "Write detailed specifications. Embed code, lists, and formatting to communicate requirements.",
    ],
    impact: [
      "Empowered remote teams with a centralized workspace eliminating communication silos through real-time sync.",
      "Implemented optimistic UI patterns for an application experience that feels instantaneous.",
      "Significantly drove user engagement and daily active usage through intuitive task management.",
    ],
    challenges: [
      {
        challenge: "Syncing collaborative data instantly.",
        solution:
          "Used MongoDB & Ably listeners for real-time updates across clients.",
      },
      {
        challenge: "Handling infinite nested task structures.",
        solution:
          "Constructed a recursive data architecture optimized for performance.",
      },
      {
        challenge: "Providing a smooth drag-and-drop experience.",
        solution:
          "Implemented Optimistic UI updates with Framer Motion for zero latency.",
      },
    ],
    mobileScreenshots: [
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770370517/jignesh-baria/Nest/ScreenShot_Tool_-20260206150404_bdtwwg.webp",
        title: "Home",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770279270/jignesh-baria/Nest/image_166_aew8ft.webp",
        title: "Home",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770279246/jignesh-baria/Nest/image_153_onmw5u.webp",
        title: "Dashboard",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770279244/jignesh-baria/Nest/image_152_qkem85.webp",
        title: "Dashboard",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770279256/jignesh-baria/Nest/image_159_jsrdln.webp",
        title: "Task Board",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770279254/jignesh-baria/Nest/image_158_pqndmd.webp",
        title: "Task Board",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770279253/jignesh-baria/Nest/image_157_ww3fqu.webp",
        title: "Project Dashboard",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770279251/jignesh-baria/Nest/image_156_v2vboe.webp",
        title: "Project Dashboard",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770279269/jignesh-baria/Nest/image_165_epcpnq.webp",
        title: "Project Menu",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770279266/jignesh-baria/Nest/image_164_oqgx4k.webp",
        title: "Project Menu",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770279264/jignesh-baria/Nest/image_163_e4hbdq.webp",
        title: "Message",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770279262/jignesh-baria/Nest/image_162_j8yn6y.webp",
        title: "Message",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770279261/jignesh-baria/Nest/image_161_xjwrt5.webp",
        title: "Contact",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770279257/jignesh-baria/Nest/image_160_hsewb2.webp",
        title: "Contact",
        type: "light",
      },
    ],
    desktopScreenshots: [
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770279216/jignesh-baria/Nest/image_49_yk4scr.webp",
        title: "Home",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770279216/jignesh-baria/Nest/image_48_oj4nfk.webp",
        title: "Home",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770279218/jignesh-baria/Nest/image_51_asqxr6.webp",
        title: "auth",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770279217/jignesh-baria/Nest/image_50_aomoem.webp",
        title: "auth",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770279223/jignesh-baria/Nest/image_54_opd9ec.webp",
        title: "Dashboard",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770279224/jignesh-baria/Nest/image_55_vn2x5r.webp",
        title: "Dashboard",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770279232/jignesh-baria/Nest/image_60_d6glgj.webp",
        title: "Task Board",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770279233/jignesh-baria/Nest/image_61_qwysp1.webp",
        title: "Task Board",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770279229/jignesh-baria/Nest/image_58_gnlljp.webp",
        title: "Project Dashboard",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770279230/jignesh-baria/Nest/image_59_fyfroi.webp",
        title: "Project Dashboard",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770279237/jignesh-baria/Nest/image_63_x27sn0.webp",
        title: "Message",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770279235/jignesh-baria/Nest/image_62_btlwo7.webp",
        title: "Message",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770279241/jignesh-baria/Nest/image_66_bvl6od.webp",
        title: "Contact",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770279243/jignesh-baria/Nest/image_67_rbu6x8.webp",
        title: "Contact",
        type: "light",
      },
    ],
  },
  {
    index: 5,
    name: "Devebsy",
    url: "https://devebsy.vercel.app/",
    href: "/our-work/devebsy",
    tag1: "Agency Portfolio & CMS",
    tag2: "High-performance digital presence with custom content management.",
    image_Gradient:
      "bg-linear-to-tr from-transparent via-indigo-600/10 to-transparent dark:from-transparent dark:via-indigo-200/10 dark:to-transparent backdrop-blur-[1px] border-2 border-indigo-200/10",
    description:
      "Designed a high-conversion agency portfolio focused on Core Web Vitals optimization. Implemented advanced animation orchestration using Framer Motion variants and scroll-linked animations, backed by a bespoke CMS layer with Tiptap for rapid content iterations.",
    gradient_light:
      "bg-linear-to-r bg-white dark:bg-main from-white dark:from-main to-indigo-500/20 dark:to-indigo-800/20 border-2 border-indigo-500/20 dark:border-indigo-800/20",
    img: "https://res.cloudinary.com/dqa59akgo/image/upload/v1770543023/jignesh-baria/posters/Poject_Poster/devebsy_light_wmyljc.webp",
    imgDark:
      "https://res.cloudinary.com/dqa59akgo/image/upload/v1770543023/jignesh-baria/posters/Poject_Poster/devebsy_dark_cqmofm.webp",
    dark: true,
    tech: [
      "NextJS 15",
      "NodeJS",
      "TypeScript",
      "Razorpay",
      "Framer-Motion",
      "Tailwind CSS",
      "Tiptap Rich-text editor",
    ],
    techIcons: [
      { name: "NextJS 15", icon: "nextjs" },
      { name: "NodeJS", icon: "nodejs" },
      { name: "TypeScript", icon: "typescript" },
      { name: "Framer-Motion", icon: "framer" },
      { name: "Tailwind CSS", icon: "tailwindcss" },
      { name: "Tiptap", icon: "tiptap" },
    ],
    features: [
      "Core Web Vitals Optimized (100% Performance)",
      "Scroll-Linked Animations (Framer Motion)",
      "Custom CMS Integration",
      "Dynamic Service Showcases",
      "Responsive & Adaptive Layouts",
      "SEO-Ready Architecture",
    ],
    featureDescription: [
      "Achieve perfect Lighthouse scores with optimized asset loading and rendering strategies.",
      "Engage users with immersive animations that respond fluidly to scroll position.",
      "Manage content effortlessly with a tailored Content Management System.",
      "Highlight services with interactive and visually consistent component designs.",
      "Deliver a flawless viewing experience on any screen size or orientation.",
      "Ensure maximum visibility on search engines with semantic HTML and meta tag optimization.",
    ],
    impact: [
      "Established a high-performance digital presence serving as a powerful lead generation tool.",
      "Achieved top-tier performance metrics by prioritizing Core Web Vitals and SEO.",
      "Reduced content management overhead with a custom CMS, allowing for rapid deployment of new case studies.",
    ],
    challenges: [
      {
        challenge: "Achieving 100% Core Web Vitals with animations.",
        solution:
          "Optimized delivery and used Framer Motion's layout animations carefully.",
      },
      {
        challenge: "Enabling rapid content iteration.",
        solution:
          "Built a bespoke CMS layer integrated with Tiptap rich-text editor.",
      },
      {
        challenge: "Creating immersive scroll experiences.",
        solution:
          "Orchestrated complex scroll-linked animations using Framer Motion.",
      },
    ],
    desktopScreenshots: [
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770486230/jignesh-baria/devebsy/image_40_ju0oja.webp",
        title: "Home",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770486230/jignesh-baria/devebsy/image_39_h0gupc.webp",
        title: "Home",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770486230/jignesh-baria/devebsy/image_41_jafklq.webp",
        title: "Services",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770486230/jignesh-baria/devebsy/image_42_nc4tco.webp",
        title: "Services",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770486231/jignesh-baria/devebsy/image_44_hzhvde.webp",
        title: "Expertise",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770486231/jignesh-baria/devebsy/image_45_qoffox.webp",
        title: "Expertise",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770486234/jignesh-baria/devebsy/image_47_a3z4g4.webp",
        title: "About",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770486232/jignesh-baria/devebsy/image_46_goancz.webp",
        title: "About",
        type: "dark",
      },
    ],
    mobileScreenshots: [
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770486236/jignesh-baria/devebsy/image_143_ztiy10.webp",
        title: "Home",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770486236/jignesh-baria/devebsy/image_144_xtczsi.webp",
        title: "Home",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770486238/jignesh-baria/devebsy/image_146_emp9oi.webp",
        title: "Services",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770486237/jignesh-baria/devebsy/image_145_d2dyrv.webp",
        title: "Services",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770486239/jignesh-baria/devebsy/image_147_wk6kpg.webp",
        title: "About",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770486241/jignesh-baria/devebsy/image_148_kwyu2r.webp",
        title: "About",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770486242/jignesh-baria/devebsy/image_150_unuquz.webp",
        title: "contact",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770486243/jignesh-baria/devebsy/image_151_m2d9x6.webp",
        title: "contact",
        type: "dark",
      },
    ],
    mainPagePoster: [
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770486760/jignesh-baria/posters/main_page/devebsy_dark-1_cuhnif.webp",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770486760/jignesh-baria/posters/main_page/devebsy_dark_oasq3n.webp",
        type: "dark",
      },
    ],
  },
  {
    index: 6,
    name: "Syncnotes",
    url: "https://syncnotes.vercel.app/",
    href: "/our-work/sync-notes",
    tag1: "Collaborative Note-Taking Ecosystem",
    tag2: "Real-time document synchronization with AI-assisted learning.",
    image_Gradient:
      "bg-linear-to-tr from-transparent via-blue-500/10 to-transparent dark:from-transparent dark:via-blue-200/10 dark:to-transparent backdrop-blur-[1px] border-2 border-blue-200/10",
    description:
      "Built an educational note-taking ecosystem featuring real-time synchronization via Firebase Realtime Database. Integrated complex document rendering including PDF generation (react-pdf) and Mathematical typesetting (KaTeX), enhanced with AI-driven study aids using the Google Gemini API.",
    gradient_light:
      "bg-linear-to-r bg-white dark:bg-main from-white dark:from-main to-blue-500/20 dark:to-blue-800/20 border-2 border-blue-500/20 dark:border-blue-800/20",
    img: "https://res.cloudinary.com/dqa59akgo/image/upload/v1770543031/jignesh-baria/posters/Poject_Poster/syncnotes_light_a6mmt6.webp",
    imgDark:
      "https://res.cloudinary.com/dqa59akgo/image/upload/v1770543030/jignesh-baria/posters/Poject_Poster/syncnotes_dark_dzjjwu.webp",
    dark: true,
    tech: [
      "NextJS 15",
      "NodeJS",
      "TypeScript",
      "Razorpay",
      "Google Gemini API",
      "Framer-Motion",
      "Tailwind CSS",
      "react-pdf",
      "React-quill with katex",
      "Firebase",
      "Zustand",
      "imagekit.io",
      "axios",
      "Markdown",
    ],
    techIcons: [
      { name: "NextJS 15", icon: "nextjs" },
      { name: "NodeJS", icon: "nodejs" },
      { name: "TypeScript", icon: "typescript" },
      { name: "Google Gemini API", icon: "gemini" },
      { name: "Framer-Motion", icon: "framer" },
      { name: "Tailwind CSS", icon: "tailwindcss" },
      { name: "Firebase", icon: "firebase" },
      { name: "Markdown", icon: "markdown" },
      { name: "Zustand", icon: "zustand" },
      { name: "Axios", icon: "axios" },
      { name: "ImageKit", icon: "imagekit" },
    ],
    features: [
      "Live Collaborative Editing",
      "LaTeX Math Support (KaTeX)",
      "PDF Generation & Export",
      "AI Study Assistant Integration",
      "Real-time Database Synchronization",
      "Advanced Markdown Editor",
    ],
    featureDescription: [
      "Collaborate on documents with multiple users in real-time.",
      "Render complex mathematical formulas and equations directly within notes.",
      "Convert notes into professional-grade PDF documents for offline sharing.",
      "Leverage AI to generate study guides and summaries from your notes.",
      "Sync data instantly across all your devices using Firebase Realtime Database.",
      "Format text quickly and efficiently with comprehensive Markdown support.",
    ],
    impact: [
      "Revolutionized digital note-taking by combining real-time collaboration with professional-grade formatting tools.",
      "Successfully supports complex academic needs for students and educators.",
      "Enabled co-creation and export of high-quality materials without leaving the browser environment.",
    ],
    challenges: [
      {
        challenge: "Enabling real-time multi-user editing.",
        solution:
          "Integrated Firebase Realtime Database for millisecond-latency sync.",
      },
      {
        challenge: "Rendering complex math and PDFs.",
        solution:
          "Utilized KaTeX for math typesetting and react-pdf for accurate export.",
      },
      {
        challenge: "Providing intelligent study assistance.",
        solution:
          "Embedded Google Gemini API to analyze notes and generate summaries.",
      },
    ],
    desktopScreenshots: [
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542784/jignesh-baria/syncnotes/image_85_e3gr9g.webp",
        title: "Home Page",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542783/jignesh-baria/syncnotes/image_84_irihiq.webp",
        title: "Home Page",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542782/jignesh-baria/syncnotes/image_69_cicnty.webp",
        title: "Auth Page",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542782/jignesh-baria/syncnotes/image_68_jggf8d.webp",
        title: "Auth Page",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542782/jignesh-baria/syncnotes/image_71_d0ghar.webp",
        title: "Dashboard",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542782/jignesh-baria/syncnotes/image_70_u0iedj.webp",
        title: "Dashboard",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542782/jignesh-baria/syncnotes/image_74_jevyw5.webp",
        title: "Subject Page",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542782/jignesh-baria/syncnotes/image_75_drkgmh.webp",
        title: "Subject Page",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542782/jignesh-baria/syncnotes/image_76_zvkp3j.webp",
        title: "PDF Viewer Page",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542782/jignesh-baria/syncnotes/image_77_cnpmhp.webp",
        title: "PDF Viewer Page",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542783/jignesh-baria/syncnotes/image_81_gjkv2e.webp",
        title: "Question Page",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542783/jignesh-baria/syncnotes/image_80_qatqjc.webp",
        title: "Question Page",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542783/jignesh-baria/syncnotes/image_79_vwta8d.webp",
        title: "Questions",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542783/jignesh-baria/syncnotes/image_78_kk44wu.webp",
        title: "Questions",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542783/jignesh-baria/syncnotes/image_82_ilvr8m.webp",
        title: "AI Page",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542783/jignesh-baria/syncnotes/image_83_yregeu.webp",
        title: "AI Page",
        type: "dark",
      },
    ],
    mobileScreenshots: [
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542798/jignesh-baria/syncnotes/image_184_p5oekp.webp",
        title: "Home Page",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542798/jignesh-baria/syncnotes/image_185_n9pdnt.webp",
        title: "Home Page",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542792/jignesh-baria/syncnotes/image_177_xyxofv.webp",
        title: "Menu",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542790/jignesh-baria/syncnotes/image_176_jlcbyf.webp",
        title: "Menu",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542784/jignesh-baria/syncnotes/image_168_fdgds9.webp",
        title: "Dashboard",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542784/jignesh-baria/syncnotes/image_169_ilmdso.webp",
        title: "Dashboard",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542789/jignesh-baria/syncnotes/image_173_svomha.webp",
        title: "Subject Page",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542789/jignesh-baria/syncnotes/image_172_wjd8tg.webp",
        title: "Subject Page",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542789/jignesh-baria/syncnotes/image_174_hmtxop.webp",
        title: "PDF Viewer Page",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542789/jignesh-baria/syncnotes/image_175_bnoklq.webp",
        title: "PDF Viewer Page",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542794/jignesh-baria/syncnotes/image_183_ht2ps7.webp",
        title: "Question Page",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542794/jignesh-baria/syncnotes/image_182_owrqp8.webp",
        title: "Question Page",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542794/jignesh-baria/syncnotes/image_181_xcliqf.webp",
        title: "Questions",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542793/jignesh-baria/syncnotes/image_180_euvdh6.webp",
        title: "Questions",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542793/jignesh-baria/syncnotes/image_179_ba2x7u.webp",
        title: "AI Page",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542793/jignesh-baria/syncnotes/image_178_wnm9e6.webp",
        title: "AI Page",
        type: "dark",
      },
    ],
    mainPagePoster: [
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770543191/jignesh-baria/posters/main_page/syncnotes_light_cvgxo7.webp",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770543189/jignesh-baria/posters/main_page/syncnotes_dark_vj5cmo.webp",
        type: "dark",
      },
    ],
  },
  {
    index: 7,
    name: "Newsmint",
    url: "https://newsmint.vercel.app/",
    href: "/our-work/newsmint",
    tag1: "High-Traffic News Aggregator",
    tag2: "SEO-optimized content delivery with Incremental Static Regeneration.",
    image_Gradient:
      "bg-linear-to-tr from-transparent via-blue-600/10 to-transparent dark:from-transparent dark:via-blue-200/10 dark:to-transparent backdrop-blur-[1px] border-2 border-blue-200/10",
    description:
      "Constructed a scalable news aggregation platform leveraging Next.js 15 SSR for maximum SEO performance. Implemented incremental static regeneration (ISR) to balance freshness with cache hit rates, utilizing Firebase Cloud Functions for backend aggregation logic.",
    gradient_light:
      "bg-linear-to-r bg-white dark:bg-main from-white dark:from-main to-blue-500/20 dark:to-blue-800/20 border-2 border-blue-500/20 dark:border-blue-800/20",
    img: "https://res.cloudinary.com/dqa59akgo/image/upload/v1770543029/jignesh-baria/posters/Poject_Poster/newsmint_light_hatunr.webp",
    imgDark:
      "https://res.cloudinary.com/dqa59akgo/image/upload/v1770543028/jignesh-baria/posters/Poject_Poster/newsmint_dark_b947rb.webp",
    dark: true,
    tech: [
      "NextJS 15",
      "NodeJS",
      "TypeScript",
      "Framer-Motion",
      "Tailwind CSS",
      "React-quill",
      "Firebase",
      "Markdown",
    ],
    techIcons: [
      { name: "NextJS 15", icon: "nextjs" },
      { name: "NodeJS", icon: "nodejs" },
      { name: "TypeScript", icon: "typescript" },
      { name: "Framer-Motion", icon: "framer" },
      { name: "Tailwind CSS", icon: "tailwindcss" },
      { name: "Firebase", icon: "firebase" },
      { name: "Markdown", icon: "markdown" },
    ],
    features: [
      "ISR for Real-time Content Updates",
      "Server-Side Rendering for SEO",
      "Automated Content Aggregation",
      "Dynamic Category Filtering",
      "Performance Optimized Loading",
    ],
    featureDescription: [
      "Refresh static content at specified intervals without rebuilding the entire site.",
      "Pre-render pages on the server to ensure content is indexable by search bots.",
      "Aggregate news from multiple sources automatically using backend scripts.",
      "Filter news by category instantly with efficient client-side logic.",
      "Minimize load times with code splitting and lazy loading of assets.",
    ],
    impact: [
      "Engineered a content delivery system that stays ahead of the news cycle while maintaining SEO dominance.",
      "Strategic use of ISR ensures content is always fresh for users and indexable for search engines.",
      "Maximized organic traffic growth and engagement.",
    ],
    challenges: [
      {
        challenge: "Balancing data freshness with SEO.",
        solution:
          "Implemented Next.js Incremental Static Regeneration (ISR) for best of both.",
      },
      {
        challenge: "Aggregating content efficiently.",
        solution:
          "Used Firebase Cloud Functions to run backend aggregation logic periodically.",
      },
      {
        challenge: "Filtering large datasets on the client.",
        solution:
          "Optimized client-side filtering logic to maintain high UI performance.",
      },
    ],
    desktopScreenshots: [
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542879/jignesh-baria/newsmint/image_87_noxuwt.webp",
        title: "Home",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542878/jignesh-baria/newsmint/image_86_xii3kt.webp",
        title: "Home",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542879/jignesh-baria/newsmint/image_88_wxxjfs.webp",
        title: "Menu",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542879/jignesh-baria/newsmint/image_89_ohpw7d.webp",
        title: "Menu",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542881/jignesh-baria/newsmint/image_91_efg782.webp",
        title: "Short-News",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542880/jignesh-baria/newsmint/image_90_jfwi5p.webp",
        title: "Short-News",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542881/jignesh-baria/newsmint/image_92_wfya5f.webp",
        title: "All-News",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542882/jignesh-baria/newsmint/image_93_bwircq.webp",
        title: "All-News",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542883/jignesh-baria/newsmint/image_95_azbaus.webp",
        title: "News Page",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542883/jignesh-baria/newsmint/image_94_oldxxj.webp",
        title: "News Page",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542885/jignesh-baria/newsmint/image_97_atrwuw.webp",
        title: "Podcast Page",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542884/jignesh-baria/newsmint/image_96_fmvtxs.webp",
        title: "Podcast Page",
        type: "dark",
      },
    ],
    mobileScreenshots: [
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542885/jignesh-baria/newsmint/image_187_nq7lmj.webp",
        title: "Home",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542888/jignesh-baria/newsmint/image_190_zopj7v.webp",
        title: "Home",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542886/jignesh-baria/newsmint/image_188_sbzldy.webp",
        title: "Menu",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542888/jignesh-baria/newsmint/image_191_dszsdq.webp",
        title: "Menu",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542892/jignesh-baria/newsmint/image_195_vbzqqa.webp",
        title: "Short-News",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542892/jignesh-baria/newsmint/image_196_m3mcdn.webp",
        title: "Short-News",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542887/jignesh-baria/newsmint/image_189_qpuwj2.webp",
        title: "Hourly News",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542890/jignesh-baria/newsmint/image_192_mkjthz.webp",
        title: "Hourly News",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542891/jignesh-baria/newsmint/image_194_r57o7b.webp",
        title: "News Page",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542890/jignesh-baria/newsmint/image_193_llm85c.webp",
        title: "News Page",
        type: "dark",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542895/jignesh-baria/newsmint/image_198_sb053j.webp",
        title: "Podcast Page",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542893/jignesh-baria/newsmint/image_197_dpzbyg.webp",
        title: "Podcast Page",
        type: "dark",
      },
    ],
    mainPagePoster: [
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770543190/jignesh-baria/posters/main_page/newmint_light_fe6el2.webp",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770543189/jignesh-baria/posters/main_page/Newsmint_dark_moyivp.webp",
        type: "dark",
      },
    ],
  },
  {
    index: 8,
    name: "FoodFast",
    url: "https://food-fast.web.app/",
    href: "/our-work/food-fast",
    tag1: "Hyperlocal Delivery Platform",
    tag2: "Geolocation-based logistics engine with complex state machines.",
    image_Gradient:
      "bg-linear-to-tr from-transparent via-green-600/10 to-transparent dark:from-transparent dark:via-green-200/10 dark:to-transparent backdrop-blur-[1px] border-2 border-green-200/10",
    description:
      "Developed a full-stack ecosystem handling complex order state machines. Implemented a robust REST API with Node.js/Express to manage inventory and geolocation logic, integrating Stripe Payment Intents API for secure transaction processing.",
    gradient_light:
      "bg-linear-to-r bg-white dark:bg-main from-white dark:from-main to-green-500/20 dark:to-green-800/20 border-2 border-green-500/20 dark:border-green-800/20",
    img: "https://res.cloudinary.com/dqa59akgo/image/upload/v1770543024/jignesh-baria/posters/Poject_Poster/foodfast_light_chdgtd.webp",
    dark: false,
    tech: [
      "ReactJS",
      "NodeJS",
      "ExpressJS",
      "TypeScript",
      "Firebase",
      "Framer-Motion",
      "Material UI",
      "Stripe",
      "Axios",
    ],
    techIcons: [
      { name: "ReactJS", icon: "react" },
      { name: "NodeJS", icon: "nodejs" },
      { name: "ExpressJS", icon: "expressjs" },
      { name: "TypeScript", icon: "typescript" },
      { name: "Firebase", icon: "firebase" },
      { name: "Framer-Motion", icon: "framer" },
      { name: "Material UI", icon: "materialui" },
      { name: "Stripe", icon: "stripe" },
      { name: "Axios", icon: "axios" },
    ],
    features: [
      "Complex Order State Management",
      "Geolocation & Address Mapping",
      "Stripe Payment Gateway",
      "Restaurant & Menu Management",
      "Real-time Order Tracking Status",
    ],
    featureDescription: [
      "Track order progress through preparation, dispatch, and delivery stages.",
      "Pinpoint delivery locations accurately with integrated map services.",
      "Accept payments securely with a seamless Stripe integration.",
      "Manage restaurant profiles and menu items with an intuitive dashboard.",
      "Receive live updates on order status via web sockets or polling.",
    ],
    impact: [
      "Built a reliable and scalable delivery network foundation managing real-time logistics complexity.",
      "Fault-tolerant state management prevents order processing errors.",
      "Ensured 100% transactional accuracy and reliability for both customers and business owners.",
    ],
    challenges: [
      {
        challenge: "Managing complex order states.",
        solution:
          "Developed a state machine within the Node.js/Express backend.",
      },
      {
        challenge: "Handling payments and refunds accurately.",
        solution:
          "Integrated Stripe Payment Intents API for secure, atomic transactions.",
      },
      {
        challenge: "Real-time delivery tracking.",
        solution:
          "Implemented robust geolocation and status polling for live updates.",
      },
    ],
    desktopScreenshots: [
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542837/jignesh-baria/foodfast/image_98_mu8hfm.webp",
        title: "Home",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542837/jignesh-baria/foodfast/image_99_y0d53r.webp",
        title: "Products",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542837/jignesh-baria/foodfast/image_100_j5nkrz.webp",
        title: "Products page",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542838/jignesh-baria/foodfast/image_101_jkyvsd.webp",
        title: "Cart page",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542838/jignesh-baria/foodfast/image_102_zobi7u.webp",
        title: "Profile page",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542839/jignesh-baria/foodfast/image_103_nmkqes.webp",
        title: "Seller page",
        type: "light",
      },
    ],
    mobileScreenshots: [
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542840/jignesh-baria/foodfast/image_199_xbnz00.webp",
        title: "Home",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542840/jignesh-baria/foodfast/image_200_hnm6xd.webp",
        title: "Products",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542840/jignesh-baria/foodfast/image_201_c2vqna.webp",
        title: "Product Page",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542841/jignesh-baria/foodfast/image_202_qiph4h.webp",
        title: "Cart Page",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542842/jignesh-baria/foodfast/image_203_gkoi37.webp",
        title: "Profile Page",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542842/jignesh-baria/foodfast/image_204_k7iyhw.webp",
        title: "Seller Page",
        type: "light",
      },
    ],
    mainPagePoster: [
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770543188/jignesh-baria/posters/main_page/food_fast_zuoslz.webp",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770543188/jignesh-baria/posters/main_page/food_fast_zuoslz.webp",
        type: "dark",
      },
    ],
  },
  {
    index: 9,
    name: "Gujarat Explorer",
    url: "https://gujarat-explorer.vercel.app/",
    href: "/our-work/gujarat-explorer",
    tag1: "Interactive Tourism Portal",
    tag2: "Immersive virtual tours with geospatial mapping integration.",
    image_Gradient:
      "bg-linear-to-tr from-transparent via-orange-600/10 to-transparent dark:from-transparent dark:via-orange-200/10 dark:to-transparent backdrop-blur-[1px] border-2 border-orange-200/10",
    description:
      "Created an immersive tourism portal featuring interactive maps and gallery virtualization. Architected a modular React frontend with Material UI theming for consistent design systems, utilizing Firebase Auth for user personalization and Firestore for efficient data querying.",
    gradient_light:
      "bg-linear-to-r bg-white dark:bg-main from-white dark:from-main to-orange-500/20 dark:to-orange-800/20 border-2 border-orange-500/20 dark:border-orange-800/20",
    img: "https://res.cloudinary.com/dqa59akgo/image/upload/v1770543025/jignesh-baria/posters/Poject_Poster/GE_light_hanzhu.webp",
    dark: false,
    tech: [
      "ReactJS",
      "NodeJS",
      "TypeScript",
      "Firebase",
      "Framer-Motion",
      "Material UI",
    ],
    techIcons: [
      { name: "ReactJS", icon: "react" },
      { name: "NodeJS", icon: "nodejs" },
      { name: "TypeScript", icon: "typescript" },
      { name: "Firebase", icon: "firebase" },
      { name: "Framer-Motion", icon: "framer" },
      { name: "Material UI", icon: "materialui" },
    ],
    features: [
      "Virtual Gallery Tours",
      "Interactive Tourism Maps",
      "User Personalization & Bookmarks",
      "Modular Component Architecture",
      "Optimized Firestore Queries",
    ],
    featureDescription: [
      "Explore gallery items in a 3D-like virtual environment.",
      "Navigate tourist spots with interactive markers and detailed overlays.",
      "Save favorite locations and create personalized travel itineraries.",
      "Build consistent user interfaces with reusable, modular components.",
      "Retrieve data efficiently with indexed queries to minimize latency and costs.",
    ],
    impact: [
      "Enhanced the digital tourism landscape by providing an engaging, interactive guide simplifying travel planning.",
      "Virtual gallery and map integration increased user time-on-site.",
      "Offered a compelling preview of destinations driving real-world visits and cultural engagement.",
    ],
    challenges: [
      {
        challenge: "Visualizing tours immersively.",
        solution: "Created virtual gallery components and interactive maps.",
      },
      {
        challenge: "Efficiently querying tourism data.",
        solution:
          "Optimized Firestore database queries/indexing for fast retrieval.",
      },
      {
        challenge: "Maintaining a consistent design system.",
        solution: "Architected a modular frontend using Material UI theming.",
      },
    ],
    desktopScreenshots: [
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542947/jignesh-baria/GE/image_104_psgjai.webp",
        title: "Home",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542948/jignesh-baria/GE/image_105_n5tdjg.webp",
        title: "Cities",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542949/jignesh-baria/GE/image_106_dowxtj.webp",
        title: "Gallery",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542949/jignesh-baria/GE/image_107_desduy.webp",
        title: "City page",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542951/jignesh-baria/GE/image_109_xsdl57.webp",
        title: "Location page",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542952/jignesh-baria/GE/image_110_qhkg0k.webp",
        title: "Gallery page",
        type: "light",
      },
    ],
    mobileScreenshots: [
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542953/jignesh-baria/GE/image_205_c7vsbf.webp",
        title: "Home",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542954/jignesh-baria/GE/image_206_lxxmvl.webp",
        title: "City Page",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542954/jignesh-baria/GE/image_207_huqzx9.webp",
        title: "Location Page",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770542955/jignesh-baria/GE/image_208_omzwrk.webp",
        title: "Gallery Page",
        type: "light",
      },
    ],
    mainPagePoster: [
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770543188/jignesh-baria/posters/main_page/GE_x3isd7.webp",
        type: "light",
      },
      {
        image:
          "https://res.cloudinary.com/dqa59akgo/image/upload/v1770543188/jignesh-baria/posters/main_page/GE_x3isd7.webp",
        type: "dark",
      },
    ],
  },
];

export const FrontArray: SkillType[] = [
  {
    index: 1,
    name: "HTML",
    title: "Semantic architecture for maximum SEO and accessibility.",
  },
  {
    index: 2,
    name: "CSS",
    title: "Responsive, pixel-perfect styling with modern layout engines.",
  },
  {
    index: 3,
    name: "JavaScript",
    title: "Advanced ES6+ logic for dynamic and interactive user experiences.",
  },
  {
    index: 4,
    name: "TypeScript",
    title:
      "Type-safe scalability for robust, maintainable enterprise codebases.",
  },
  {
    index: 5,
    name: "Tailwind CSS",
    title: "Rapid, consistent design system implementation for modern UIs.",
  },
  {
    index: 6,
    name: "Core Java",
    title: "Object-oriented backend logic and high-efficiency data processing.",
  },
  {
    index: 7,
    name: "Solidity",
    title: "Currently Learning for web3",
  },
];

export const TechArray: SkillType[] = [
  {
    index: 1,
    name: "Node Js",
    title: "High-performance, event-driven backend services and microservices.",
  },
  {
    index: 2,
    name: "Express Js",
    title:
      "Robust RESTful API architecture with scalable middleware integration.",
  },
  {
    index: 3,
    name: "ReactJS",
    title:
      "Component-based UI architecture for complex, state-driven applications.",
  },
  {
    index: 4,
    name: "NextJS 13+",
    title:
      "Production-grade full-stack framework with advanced SSR, ISR, and API routes.",
  },
  {
    index: 5,
    name: "Gatsby",
    title:
      "Blazing fast static site generation for performance-critical content platforms.",
  },
  {
    index: 6,
    name: "React Native",
    title:
      "Cross-platform mobile application development with a unified codebase.",
  },
];

export const Database: SkillType[] = [
  {
    index: 1,
    name: "NoSQL",
    title:
      "Flexible schema design for handling rapidly evolving unstructured data.",
  },
  {
    index: 2,
    name: "MongoDB",
    title: "Scalable document storage with powerful aggregation capabilities.",
  },
  {
    index: 3,
    name: "Firebase",
    title:
      "Rapid prototyping platform with real-time data synchronization and auth.",
  },
  {
    index: 4,
    name: "Appwrite",
    title:
      "Secure, self-hosted backend infrastructure for specialized deployments.",
  },
];

export const Other: SkillType[] = [
  {
    index: 1,
    name: "Rest API",
    title:
      "Standardized, stateless communication protocols for system interoperability.",
  },
  {
    index: 2,
    name: "GIT",
    title:
      "Collaborative version control with branch management and CI/CD pipelines.",
  },
  {
    index: 3,
    name: "GraphQL",
    title:
      "Efficient data fetching allowing clients to request exactly what they need.",
  },
];

export const AITools: SkillType[] = [
  {
    index: 1,
    name: "Genkit",
    title:
      "Automating complex logic and content generation with Google's frameworks.",
  },
  {
    index: 2,
    name: "Google Gemini API",
    title:
      "Integrating multimodal AI capabilities into production applications.",
  },
  {
    index: 3,
    name: "OpenAI API",
    title:
      "Leveraging industry-leading LLMs for intelligent features and automation.",
  },
];